import MenuContainer from './MenuContainer';
import MenuItem from './MenuItem';

const MenuTable = {
  Container: MenuContainer,
  Item: MenuItem
};

export default MenuTable;
